import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "./../../api/apiConnectCaller";

export const GET_LOG_CALLS_IN_BOUND = "GET_LOG_CALLS_IN_BOUND";
export const GET_LOG_CALLS_IN_BOUND_ERROR = "GET_LOG_CALLS_IN_BOUND_ERROR";
export const GET_LOG_CALLS_IN_BOUND_SUCCESS = "GET_LOG_CALLS_IN_BOUND_SUCCESS";

export const GET_LOG_CALLS_OUT_BOUND = "GET_LOG_CALLS_OUT_BOUND";
export const GET_LOG_CALLS_OUT_BOUND_ERROR = "GET_LOG_CALLS_OUT_BOUND_ERROR";
export const GET_LOG_CALLS_OUT_BOUND_SUCCESS =
  "GET_LOG_CALLS_OUT_BOUND_SUCCESS";
/**
 * Reducer
 */

const initialState = {
  inBounds: [],
  inBound: {},
  outBounds: [],
  outBound: {},
  error: false,
};

export const callLogsReducer = (state = initialState, action) => {
  // if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  //     console.log(action)
  // }
  switch (action.type) {
    case GET_LOG_CALLS_IN_BOUND:
      return {
        ...state,
        inBounds: [],
      };
    case GET_LOG_CALLS_IN_BOUND_SUCCESS:
      return {
        ...state,
        inBounds: action.payload.data,
        error: false,
      };
    case GET_LOG_CALLS_IN_BOUND_ERROR:
      return {
        ...state,
        error: action.error,
      };

    //out bound

    case GET_LOG_CALLS_OUT_BOUND:
      return {
        ...state,
        outBounds: [],
      };
    case GET_LOG_CALLS_OUT_BOUND_SUCCESS:
      return {
        ...state,
        outBounds: action.payload.data,
        error: false,
      };
    case GET_LOG_CALLS_OUT_BOUND_ERROR:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
};

/**
 * Action
 */

export const postInBoundAction = (queryTime) => ({
  type: GET_LOG_CALLS_IN_BOUND,
  data: {
    queryTime,
  },
});

export const postOutBoundAction = (queryTime) => ({
  type: GET_LOG_CALLS_OUT_BOUND,
  data: {
    queryTime,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      postInBoundAction,
      postOutBoundAction,
    },
    dispatch
  );
};

/**
 * Apis
 */

const postInBoundApi = (queryTime) => {
  return apiCaller.post(
    `${process.env.REACT_APP_API_CONNECT}/call-logs/inbound`,
    {
      queryTime,
    }
  );
};

const postOutBoundApi = (queryTime) => {
  return apiCaller.post(
    `${process.env.REACT_APP_API_CONNECT}/call-logs/outbound`,
    {
      queryTime,
    }
  );
};

/**
 * sagas
 */

export const postInBoundFlow = function* () {
  while (true) {
    const action = yield take(GET_LOG_CALLS_IN_BOUND);
    try {
      const res = yield call(postInBoundApi, action.data.queryTime);
      yield put({
        type: GET_LOG_CALLS_IN_BOUND_SUCCESS,
        payload: {
          ...res.data,
        },
        data: action.data,
      });
    } catch (error) {
      yield put({ type: GET_LOG_CALLS_IN_BOUND_ERROR, error });
    }
  }
};

export const postOutBoundFlow = function* () {
  while (true) {
    const action = yield take(GET_LOG_CALLS_OUT_BOUND);
    try {
      const res = yield call(postOutBoundApi, action.data.queryTime);
      yield put({
        type: GET_LOG_CALLS_OUT_BOUND_SUCCESS,
        payload: {
          ...res.data,
        },
        data: action.data,
      });
    } catch (error) {
      yield put({ type: GET_LOG_CALLS_OUT_BOUND_ERROR, error });
    }
  }
};
